"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _document = require("../utils/dom/document");

var _styles = require("../styles");

var _uid = require("../utils/uid");

var _func = require("../utils/func");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DIS_LIMIT = 50;

var _default = (0, _func.curry)(function (handler, Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(Moveable, _React$Component);

    function Moveable(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.state = {
        x: 0,
        y: 0,
        draging: false
      };
      _this.moveabledId = (0, _uid.getUidStr)();
      _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    var _proto = Moveable.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.bindEvent();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this.el) {
        this.el.removeEventListener('mousedown', this.handleMouseDown);
      }
    };

    _proto.getStyle = function getStyle() {
      var _this$state = this.state,
          x = _this$state.x,
          y = _this$state.y;
      if (!this.hasDragged) return undefined;
      return {
        transform: "translate(" + x + "px, " + y + "px)"
      };
    };

    _proto.bindEvent = function bindEvent() {
      this.el = document.querySelector("." + (0, _styles.moveableClass)(this.moveabledId));
      if (!this.el) return;
      this.el.addEventListener('mousedown', this.handleMouseDown);
      this.handlerEl = handler ? this.el.querySelector(handler) || this.el : this.el;
    };

    _proto.handleMouseDown = function handleMouseDown(e) {
      if (e.button !== 0 || !this.el) return;
      if (handler && !e.target.matches(handler)) return;
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
      document.addEventListener('mouseleave', this.handleMouseUp);

      if (!this.handlerPos) {
        this.handlerPos = this.handlerEl.getBoundingClientRect();
      }

      this.hasDragged = true;
      this.setState({
        draging: true
      });
    };

    _proto.handleMouseMove = function handleMouseMove(e) {
      var _this2 = this;

      this.setState(function (prev) {
        var x = prev.x + e.movementX;
        var y = prev.y + e.movementY;

        if (_this2.handlerPos.right + x < DIS_LIMIT || _this2.handlerPos.left + x > _document.docSize.width - DIS_LIMIT) {
          // eslint-disable-next-line prefer-destructuring
          x = prev.x;
        }

        if (_this2.handlerPos.bottom + y < DIS_LIMIT || _this2.handlerPos.top + y > _document.docSize.height - DIS_LIMIT) {
          // eslint-disable-next-line prefer-destructuring
          y = prev.y;
        }

        return {
          x: x,
          y: y
        };
      });
    };

    _proto.handleMouseUp = function handleMouseUp() {
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
      document.removeEventListener('mouseleave', this.handleMouseUp);
      this.setState({
        draging: false
      });
    };

    _proto.render = function render() {
      var _this$props = this.props,
          moveable = _this$props.moveable,
          others = _objectWithoutPropertiesLoose(_this$props, ["moveable"]);

      if (!moveable) return _react.default.createElement(Origin, others);
      var ms = Object.assign({}, this.props.style, this.getStyle());
      var mc = (0, _classnames.default)(this.props.className, (0, _styles.moveableClass)('_', this.moveabledId, this.state.draging && 'draging'));
      return _react.default.createElement(Origin, _extends({}, others, {
        style: ms,
        className: mc
      }));
    };

    return Moveable;
  }(_react.default.Component), _defineProperty(_class, "propTypes", {
    style: _propTypes.default.object,
    className: _propTypes.default.string,
    moveable: _propTypes.default.bool
  }), _temp;
});

exports.default = _default;